import { request } from 'utils/ajax';

export interface UserInfoResponse {
    email: string;
    firstName: string;
    lastName: string;
    isLoggedIn: boolean;
}

export function getCurrentUser(): Promise<UserInfoResponse> {
    return request('api/auth/current-user').then((x) => x.json());
}

export function logout(): Promise<any> {
    return request('api/auth/logout', { method: 'POST' });
}

export function getLoginUrl(returnUrl: string) {
    const relativePath = `api/auth/login/external?returnUrl=${encodeURIComponent(returnUrl)}`;
    if (window.location.host.startsWith('localhost')) {
        return 'https://localhost:44333/' + relativePath;
    }

    return relativePath;
}